module.exports = __webpack_public_path__ + "static/media/eyeshadow.3cca7dda.png";